
import {React, useState, useContext, useEffect, useRef} from "react"
import{UserContext} from '../../context/userContext/userContext';
import { useStyle } from '../../context/styleContext/styleContext';
import ReactGA from 'react-ga4';
import Seo from "../../components/Seo";


export default function Contact(){

  const { user } = useContext(UserContext);
  const { isLoading } = useContext(UserContext);
  const { style, setStyle } = useStyle();

  const [height, setHeight] = useState(window.innerHeight)
  const [width, setWidth] = useState(window.setWidth)

  useEffect(() => {
    function handleResize() {      
      setWidth(window.innerWidth)
      setHeight(window.innerHeight)
  }
  
    window.addEventListener('resize', handleResize)
  })

  const topContainer = useRef();
  useEffect(() => {
      // To make sure page starts from the top
      topContainer.current.scrollIntoView({ block: "end" });
  }, []);




    return(
        <>
<Seo
  title="Contact Parish Audio | Support and Questions"
  description="Contact Parish Audio for plugin questions, support, product help, and general inquiries."
  canonical="https://parishaudio.com/contact"
/>
<div style={{backgroundImage: `url("/RecordingStudioStockImage1.jpg")`, backgroundSize: "cover", backgroundPosition: "center", marginBottom:'0px'}}>
        <div style={{flex:1, backgroundColor:'rgba(0,0,0,.7'}}>



        <div ref={topContainer} style={{display:'flex', flexDirection:'column', width:'95%', maxWidth:'1000px', minHeight:height - 130, margin:'auto'}}>
          <div style={{textAlign:'center', color: style.color4,}}>
            <h1 style={{ marginTop:'50px', marginBottom:'50px'}}> Contact</h1>
            <strong style={{ marginTop:'100px', marginBottom:'0px', color:style.color4}}>
                Comments? Feedback? Please send an email to:
                </strong><div style={{marginTop:'20px'}}>
                <a href="mailto:support@parishaudio.com" style={{color:style.color2, fontSize:'18pt'}}><strong>support@parishaudio.com</strong></a></div>
            </div>
          </div>

          </div>
          </div>

        </>

    )
}